module.exports = __webpack_public_path__ + "img/2023-12_powerhouse2.c52e0f40.jpg";